export default (state = true, action) => {
  switch (action.type) {
    case 'toggleHideStopRequests':
      return typeof action.payload === 'boolean' ? action.payload : !state
    default:
      return state
  }
}
